import { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Divider,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";

import main from "../../assets/scss/main.module.scss";
import { Balance } from "../common/Balance";
import { ExchangeModal } from "./ExchangeModal";
import { MethodModal } from "../common/MethodModal";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CustomAxios from "../../utils/CustomAxios";

const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSd0Xs36m1qJx0dgDwFBh9kHTlxmIBZ4vY1WAcBf9sjrUD013Q/viewform?usp=header";

export const JCredit = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBuyMenuOpen, setIsBuyMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exchangeType, setExchangeType] = useState<"buy" | "sell">("buy");
  const [paymentMethod, setPaymentMethod] = useState<"balance" | "credit">(
    "balance"
  );
  const [currentSellRate, setCurrentSellRate] = useState<number>(0);
  const [currentBuyRate, setCurrentBuyRate] = useState<number>(0);

  useEffect(() => {
    setIsLoading(true);
    CustomAxios.get("/jcredit/current")
      .then((res) => {
        setCurrentSellRate(res.data.sell);
        setCurrentBuyRate(res.data.buy);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: main.colorLightGreen,
          py: 2,
          mt: "110px",
          mb: 2,
        }}
      >
        <Paper
          elevation={1}
          sx={{ width: "90%", mx: "auto", p: 2, borderRadius: "16px" }}
        >
          <Balance type="jCredit" />
          <Divider sx={{ mt: 2 }} />
          <Button
            variant="text"
            disabled={true}
            onClick={() => {
              setIsBuyMenuOpen(true);
              setExchangeType("buy");
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
                width: "130px",
              }}
            >
              <LoyaltyIcon fontSize="medium" />
              購入する
            </Box>
          </Button>
          <Button
            variant="text"
            disabled={true}
            onClick={() => {
              setIsModalOpen(true);
              setExchangeType("sell");
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
                width: "130px",
              }}
            >
              <CurrencyYenIcon fontSize="medium" />
              換金する
            </Box>
          </Button>
        </Paper>

        <MethodModal
          isOpen={isBuyMenuOpen}
          setIsOpen={setIsBuyMenuOpen}
          title="購入方法を選択"
          methodList={[
            {
              icon: <CurrencyYenIcon />,
              title: "残高",
              onClick: () => {
                setPaymentMethod("balance");
                setIsModalOpen(true);
              },
            },
            {
              icon: <CreditCardIcon />,
              title: "クレジット",
              onClick: () => {
                setPaymentMethod("credit");
                setIsModalOpen(true);
              },
              disabled: true,
            },
          ]}
        />

        <Paper
          elevation={1}
          sx={{
            width: "90%",
            mx: "auto",
            mt: 2,
            p: 2,
            borderRadius: "16px",
          }}
        >
          <Typography>現在のレート</Typography>
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 1,
                  justifyContent: "space-between",
                  my: 4,
                }}
              >
                <Typography>購入レート</Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    {currentBuyRate.toLocaleString()}
                  </Typography>
                  <Typography>円</Typography>
                  <Typography>=</Typography>
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    1
                  </Typography>
                  <Typography>t-CO2</Typography>
                </Box>
              </Box>
              <Divider sx={{ mt: 2 }} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 1,
                  justifyContent: "space-between",
                  my: 4,
                }}
              >
                <Typography>換金レート</Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    1
                  </Typography>
                  <Typography>t-CO2</Typography>
                  <Typography>=</Typography>
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    {currentSellRate.toLocaleString()}
                  </Typography>
                  <Typography>円</Typography>
                </Box>
              </Box>
            </>
          )}
        </Paper>
      </Paper>
      <Button
        variant="contained"
        size="large"
        disabled={true}
        onClick={() => {
          window.open(FORM_URL, "_blank");
        }}
        sx={{ width: "90%", mx: "auto", mt: 2 }}
      >
        カーボンオフセット申請
      </Button>

      <ExchangeModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        exchangeType={exchangeType}
        paymentMethod={paymentMethod}
        currentBuyRate={currentBuyRate}
        currentSellRate={currentSellRate}
      />
    </>
  );
};
